/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  InvestorEntityData
} from '../../model/investorEntityData'
import type {
  InvestorEntityDataList
} from '../../model/investorEntityDataList'
import type {
  InvestorEntityDataRequest
} from '../../model/investorEntityDataRequest'
import type {
  InvestorEntityListParams
} from '../../model/investorEntityListParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a list of Investor Entities
 */
export const investorEntityList = (
    params?: InvestorEntityListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorEntityDataList>(
      {url: `/investor-entity/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInvestorEntityListQueryKey = (params?: InvestorEntityListParams,) => {
    return [`/investor-entity/`, ...(params ? [params]: [])] as const;
    }

    
export const getInvestorEntityListQueryOptions = <TData = Awaited<ReturnType<typeof investorEntityList>>, TError = unknown>(params?: InvestorEntityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorEntityListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorEntityList>>> = ({ signal }) => investorEntityList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorEntityList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorEntityListQueryResult = NonNullable<Awaited<ReturnType<typeof investorEntityList>>>
export type InvestorEntityListQueryError = unknown

export const useInvestorEntityList = <TData = Awaited<ReturnType<typeof investorEntityList>>, TError = unknown>(
 params?: InvestorEntityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorEntityListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorEntityListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorEntityList>>, TError = unknown>(params?: InvestorEntityListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorEntityListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorEntityList>>> = ({ signal }) => investorEntityList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorEntityList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorEntityListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorEntityList>>>
export type InvestorEntityListSuspenseQueryError = unknown

export const useInvestorEntityListSuspense = <TData = Awaited<ReturnType<typeof investorEntityList>>, TError = unknown>(
 params?: InvestorEntityListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorEntityListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorEntityListLoader = (queryParamsOrFn?: (InvestorEntityListParams | ((params: Params) => InvestorEntityListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getInvestorEntityListQueryKey(queryParams),
            queryFn: () => investorEntityList(queryParams),
          }).then(() => null);
        });
      /**
 * Create a new Investor Entity and associate it with an existing Investor
 */
export const investorEntityCreate = (
    investorEntityDataRequest: InvestorEntityDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorEntityData>(
      {url: `/investor-entity/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investorEntityDataRequest
    },
      options);
    }
  


export const getInvestorEntityCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityCreate>>, TError,{data: InvestorEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorEntityCreate>>, TError,{data: InvestorEntityDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorEntityCreate>>, {data: InvestorEntityDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  investorEntityCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorEntityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof investorEntityCreate>>>
    export type InvestorEntityCreateMutationBody = InvestorEntityDataRequest
    export type InvestorEntityCreateMutationError = unknown

    export const useInvestorEntityCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityCreate>>, TError,{data: InvestorEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorEntityCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific Investor Entity
 */
export const investorEntityRetrieve = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestorEntityData>(
      {url: `/investor-entity/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestorEntityRetrieveQueryKey = (id: string,) => {
    return [`/investor-entity/${id}/`] as const;
    }

    
export const getInvestorEntityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorEntityRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorEntityRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorEntityRetrieve>>> = ({ signal }) => investorEntityRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorEntityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorEntityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorEntityRetrieve>>>
export type InvestorEntityRetrieveQueryError = unknown

export const useInvestorEntityRetrieve = <TData = Awaited<ReturnType<typeof investorEntityRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorEntityRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorEntityRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorEntityRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorEntityRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorEntityRetrieve>>> = ({ signal }) => investorEntityRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorEntityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorEntityRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorEntityRetrieve>>>
export type InvestorEntityRetrieveSuspenseQueryError = unknown

export const useInvestorEntityRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorEntityRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorEntityRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorEntityRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (id) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorEntityRetrieveQueryKey(id),
              queryFn: () => investorEntityRetrieve(id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a specific Investor Entity
 */
export const investorEntityUpdate = (
    id: string,
    investorEntityDataRequest: InvestorEntityDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestorEntityData>(
      {url: `/investor-entity/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: investorEntityDataRequest
    },
      options);
    }
  


export const getInvestorEntityUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityUpdate>>, TError,{id: string;data: InvestorEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorEntityUpdate>>, TError,{id: string;data: InvestorEntityDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorEntityUpdate>>, {id: string;data: InvestorEntityDataRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  investorEntityUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorEntityUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof investorEntityUpdate>>>
    export type InvestorEntityUpdateMutationBody = InvestorEntityDataRequest
    export type InvestorEntityUpdateMutationError = unknown

    export const useInvestorEntityUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityUpdate>>, TError,{id: string;data: InvestorEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorEntityUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a specific Investor Entity
 */
export const investorEntityDestroy = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/investor-entity/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getInvestorEntityDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investorEntityDestroy>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investorEntityDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  investorEntityDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestorEntityDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof investorEntityDestroy>>>
    
    export type InvestorEntityDestroyMutationError = unknown

    export const useInvestorEntityDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investorEntityDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestorEntityDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    